/** @jsxImportSource @emotion/react */
import { keyframes } from '@emotion/react';
import {
  createStyles,
  Icon,
  useTheme,
  Tooltip,
} from '@quickbit/qb-design-system';
import { useIntl } from 'react-intl';

export const RenderStatusTooltip = ({ status }: { status: string }) => {
  const styles = useStyles();
  const { spacing } = useTheme();
  const { formatMessage } = useIntl();
  switch (status) {
    case 'FAILED':
      return (
        <Tooltip
          title={formatMessage({ id: 'transactionFailed' })}
          placement="top"
        >
          <Icon name="error" size={spacing.xxs} />
        </Tooltip>
      );
    case 'PENDING':
    case 'PENDING_TRAVEL_RULE':
      return (
        <Tooltip
          title={formatMessage({ id: 'regulatoryDelayNotice' })}
          placement="top"
        >
          <div css={[{ ...styles.dot }, { ...styles.statusPending }]} />
        </Tooltip>
      );
    default:
      return (
        <Tooltip
          title={formatMessage({ id: 'transactionCompleted' })}
          placement="top"
        >
          <div css={styles.statusSuccess}>
            <Icon name="checkmark" size={spacing.xxs} />
          </div>
        </Tooltip>
      );
  }
};

const useStyles = createStyles(({ palette, spacing }) => ({
  dot: {
    height: spacing.xxxs,
    width: spacing.xxxs,
    borderRadius: '50%',
    boxShadow: '0 0 0 0 rgba(255, 177, 66, 1)',
    display: 'inline-block',
    transform: 'scale(1)',
    animation: `${keyframes`
      0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 177, 66, 0.7);
      }
      70% {
        transform: scale(1);
        box-shadow: 0 0 0 ${spacing.xxxs} rgba(255, 177, 66, 0);
      }
      100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 177, 66, 0);
      }
      `} 2s infinite`,
  },
  statusSuccess: {
    svg: {
      fill: 'none',
      stroke: palette.success.default,
    },
  },
  statusPending: {
    backgroundColor: palette.warning.default,
  },
}));
